/* eslint-disable arrow-body-style */
import React from 'react';
import { Grid, Typography, Box, Divider, Stack } from '@mui/material';
import dayjs from 'dayjs';
import moment from 'moment';
import { SignView } from './SignView';

const TimeEntryView = ({ data }) => {
    // const getTotalMainTime = () => {
    //     if (data.activityTime?.startTime && data.activityTime?.endTime) {
    //         return dayjs(data.activityTime.endTime).diff(dayjs(data.activityTime.startTime), 'minute');
    //     }
    //     return 0;
    // };

    // const getTotalAdditionalTime = () => (data.additionalActivityTime || []).reduce((sum, item) => sum + Number(item.time || 0), 0);

    const totalTime = data?.time_entry_details_time_entry?.reduce((sum, item) => sum + (Number(item?.minutes) || 0), 0);

    return (
        <Box sx={{ mt: 1, p: 3, border: '1px solid #e0e0e0', borderRadius: 2, backgroundColor: '#fafafa' }}>
            <Grid container spacing={2}>
                {/* Basic Info */}
                <Grid item xs={12} sm={6}>
                    <Typography variant="body2">
                        <strong>Location:</strong> {data.location?.name || '-'}
                    </Typography>
                </Grid>
                <Grid item xs={12} sm={6}>
                    <Typography variant="body2">
                        <strong>Therapist:</strong> {data.therapist?.name || '-'}
                    </Typography>
                </Grid>
                <Grid item xs={12} sm={6}>
                    <Typography variant="body2">
                        <strong>Service:</strong> {data.service?.service_name || '-'}
                    </Typography>
                </Grid>
                <Grid item xs={12} sm={6}>
                    <Typography variant="body2">
                        <strong>Date:</strong> {dayjs(data.date).format('MM/DD/YYYY') || '-'}
                    </Typography>
                </Grid>
            </Grid>

            <Divider sx={{ my: 2 }} />

            {/* Time Info */}
            <Grid container spacing={2}>
                {/* <Grid item xs={12} sm={6}>
                    <Typography variant="body2">
                        <strong>Start Time:</strong> {data?.start_time ? moment.utc(data.start_time).local().format('hh:mm A') : '-'}
                    </Typography>
                </Grid>
                <Grid item xs={12} sm={6}>
                    <Typography variant="body2">
                        <strong>End Time:</strong> {data?.end_time ? moment.utc(data.end_time).local().format('hh:mm A') : '-'}
                    </Typography>
                </Grid> */}
                <Grid item xs={12}>
                    <Typography variant="body2" fontWeight="bold">
                        Total Duration: {totalTime} minutes
                    </Typography>
                </Grid>
            </Grid>

            {/* Additional Activities */}
            {data?.time_entry_details_time_entry?.length > 0 && (
                <>
                    <Divider sx={{ my: 2 }} />
                    <Typography variant="subtitle1" fontWeight="bold" gutterBottom>
                        Additional Activities
                    </Typography>
                    <Stack spacing={1}>
                        {data.time_entry_details_time_entry.map((item, index) => (
                            <Box key={index} sx={{ pl: 1 }}>
                                <Typography variant="body2">
                                    <strong>{index + 1}.</strong> <strong>Activity:</strong> {item.activity_log_setup?.name || '-'} |{' '}
                                    <strong>Count:</strong> {item?.num_of_activity} | <strong>Time:</strong> {item?.minutes} minutes{' '}
                                    {item?.campus?.name && (
                                        <>
                                            | <strong>Campus:</strong> {item.campus.name}
                                        </>
                                    )}
                                </Typography>
                            </Box>
                        ))}
                    </Stack>
                </>
            )}

            <Grid>
                <SignView data={data} parent="view" />
            </Grid>
        </Box>
    );
};

export default TimeEntryView;
